import { Directive, OnChanges, Input, ElementRef } from '@angular/core';
import * as screenfull from '../../../../../assets/js/fullscreen.js';

@Directive({
    selector: '[ngxToggleFullscreen]',
    standalone: false
})
export class ToggleFullscreenDirective implements OnChanges {

    @Input('ngxToggleFullscreen')
    isFullscreen: boolean;

    constructor(private el: ElementRef) { }

    ngOnChanges() {
        if (this.isFullscreen && screenfull.enabled) {
            screenfull.request(this.el.nativeElement);
        } else if (screenfull.enabled) {
            screenfull.exit();
        }
    }

}
